import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Text, factory, useProps } from "@components/mantine";
import { Locales } from "../../../strings/Locales.js";
import { useSourceIdentityContext } from "../SourceIdentityContext.js";
var defaultProps = {
    size: "md"
};
export var SourceIdentityTypeLabel = factory(function(props, ref) {
    var _ref = useProps("SourceIdentityTypeLabel", defaultProps, props), size = _ref.size, others = _object_without_properties(_ref, [
        "size"
    ]);
    var _$ref = useSourceIdentityContext(), getStyles = _$ref.getStyles, sourceType = _$ref.sourceType;
    return /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({
        ref: ref
    }, getStyles("typeLabel"), others), {
        flex: 1,
        children: /*#__PURE__*/ _jsx(Text, {
            size: size,
            children: Locales.format("SourceIdentity.sourceType.".concat(sourceType, ".label"))
        })
    }));
});
SourceIdentityTypeLabel.displayName = "@resourceIdentity/source/SourceIdentity/TypeLabel";

//# sourceMappingURL=SourceIdentityTypeLabel.js.map